export default "__VITE_ASSET__Cxz3Ya7E__"